import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Fournisseur, Telephone } from '../../../../../models/fournisseur';
import * as Feather from 'feather-icons';

@Component({
    selector: 'app-fourniss-detail-profil',
    templateUrl: './fourniss-detail-profil.component.html',
    styleUrls: ['./fourniss-detail-profil.component.scss']
})
export class FournissDetailProfilComponent implements OnInit {
    @Input() fournisseur: Fournisseur | null = null;
    @Input() isLoading: boolean = false;

    constructor(private toastr: ToastrService) {}

    ngOnInit(): void {
        setTimeout(() => Feather.replace(), 0);
    }


    hasEmail(): boolean {
        return this.fournisseur?.emails?.length > 0 && !!this.fournisseur.emails[0]?.email;
    }

    hasPhone(): boolean {
        return this.fournisseur?.telephones?.length > 0 &&
            !!this.fournisseur.telephones[0]?.num_tel;
    }

    getFirstEmail(): string {
        return this.fournisseur?.emails?.[0]?.email || '';
    }

    getFirstPhone(): any {
        return this.fournisseur?.telephones?.[0] || { code_pays: '', num_tel: '' };
    }

    getWhatsAppLink(telephone: Telephone): string {
        if (!telephone?.num_tel || !telephone?.code_pays) {
            return '#';
        }
        const phoneNumber = telephone.code_pays.replace(/\D/g, '') + telephone.num_tel.replace(/\D/g, '');
        return `https://wa.me/${phoneNumber}`;
    }
}
